import React, { useRef } from 'react'
import Select from '@blocks/Select'

export default function GallerySort({ archive }: Props) {
    const sort = useRef<ReturnType<ArchiveHookSortFn<ArchiveHookResponse<Interfaces.Photo.Includes<"awards_count" | "salons_count" | "acceptances_count">>>>>()

    if (!archive.data?.length)
        return null

    return (
        <Select 
            id="sort" 
            name="sort" 
            height="s" 
            placeholder="Sort By" 
            options={[
                { label: `Salons`, value: "salons" },
                { label: `Acceptances`, value: "acceptances" },
                { label: `Awards`, value: "awards" }
            ]}
            onChange={
                (option: Interfaces.Options<"salons" | "acceptances" | "awards">[0]) => {
                    if (!option?.value) {
                        sort.current?.reset()
                        return
                    }

                    switch (option.value) {
                        case 'acceptances':
                            sort.current = archive.sort(sortByAcceptancesCount)
                            break
                        case 'awards':
                            sort.current = archive.sort(sortByAwardsCount)
                            break
                        case 'salons':
                            sort.current = archive.sort(sortBySalonsCount)
                            break
                    }
                    
                    sort.current.set()
                }
            } />
    )
}

interface Props {
    archive: ArchiveHookResponse<Interfaces.Photo.Includes<"awards_count" | "salons_count" | "acceptances_count">>
}

const sortByAcceptancesCount: CompareFunction<Interfaces.Photo.Includes<"salons_count" | "awards_count" | "acceptances_count">> = (a, b) => {
    return b.acceptances_count - a.acceptances_count
}

const sortByAwardsCount: CompareFunction<Interfaces.Photo.Includes<"salons_count" | "awards_count" | "acceptances_count">> = (a, b) => {
    return b.awards_count - a.awards_count
}

const sortBySalonsCount: CompareFunction<Interfaces.Photo.Includes<"salons_count" | "awards_count" | "acceptances_count">> = (a, b) => {
    return b.salons_count - a.salons_count
}